"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.languageConvert = void 0;
const languageConvert = {
    'en-US': 'en',
    'vi-VN': 'vn',
    'my-MM': 'my',
    'tha-TH': 'th',
    'us-en': 'en',
};
exports.languageConvert = languageConvert;
